































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import ZenMultiselect from '@reciprocity/multiselect';

import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';

import { downloadImportTemplate } from '../download';

export default Vue.extend({
  name: 'TemplateDownload',
  components: {
    GenericCard,
    ZenMultiselect,
  },
  data() {
    return {
      selectedObjectTypes: [],
    };
  },
  computed: {
    ...mapGetters(['csrfToken', 'importableObjects']),
  },
  created() {
    this.changeModalSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      showAlert: 'alerts/show',
    }),
    async downloadTemplate() {
      const data = this.selectedObjectTypes.map(objectType => ({
        object_name: objectType.modelSingular,
        fields: 'all',
      }));

      try {
        await downloadImportTemplate('import_template.csv', data, this.csrfToken);
        this.$emit('close');
      } catch (error) {
        this.showAlert(error);
      }
    },
  },
});
